import "core-js/modules/es6.object.define-property";
import _path5 from "path";
import _universalImport5 from "babel-plugin-universal-import/universalImport";
import _path4 from "path";
import _universalImport4 from "babel-plugin-universal-import/universalImport";
import _path3 from "path";
import _universalImport3 from "babel-plugin-universal-import/universalImport";
import _path2 from "path";
import _universalImport2 from "babel-plugin-universal-import/universalImport";
import "core-js/modules/es6.promise";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import _path from "path";
import _universalImport from "babel-plugin-universal-import/universalImport";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { MARKETPLACE, MARKETPLACE_NAMED_QUERIES, WORDPRESS, WORDPRESS_SEARCH, WORDPRESS_TABLES } from './types/providers'; // returns a providers map for nerdwallet-specific configured providers

export default function createNerdwalletProviders() {
  var _ref;

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var nwApiSdk = options.nwApiSdk,
      appConfig = options.appConfig,
      schema = options.schema,
      serverRequest = options.serverRequest; // TODO: modularize this options checking so it can be reused by native version of this file

  if (!nwApiSdk) throw new Error('`nwApiSdk` required to createNerdwalletProviders'); // eslint-disable-line prettier/prettier

  if (!appConfig) throw new Error('`appConfig` required to createNerdwalletProviders'); // eslint-disable-line prettier/prettier

  return _ref = {}, _defineProperty(_ref, MARKETPLACE, function () {
    return _universalImport({
      id: "./providers/marketplace",
      load: function load() {
        return Promise.all([import(
        /* webpackChunkName: 'providers/marketplace' */
        './providers/marketplace')]).then(function (proms) {
          return proms[0];
        });
      },
      path: function path() {
        return _path.join(__dirname, './providers/marketplace');
      },
      resolve: function resolve() {
        return require.resolveWeak('./providers/marketplace');
      },
      chunkName: function chunkName() {
        return "providers/marketplace";
      }
    }).then(function (module) {
      return module["default"]({
        nwApiSdk: nwApiSdk,
        appConfig: appConfig,
        serverRequest: serverRequest
      });
    });
  }), _defineProperty(_ref, MARKETPLACE_NAMED_QUERIES, function () {
    return _universalImport2({
      id: "./providers/marketplace-named-queries",
      load: function load() {
        return Promise.all([import(
        /* webpackChunkName: 'providers/marketplace-named-queries' */
        './providers/marketplace-named-queries')]).then(function (proms) {
          return proms[0];
        });
      },
      path: function path() {
        return _path2.join(__dirname, './providers/marketplace-named-queries');
      },
      resolve: function resolve() {
        return require.resolveWeak('./providers/marketplace-named-queries');
      },
      chunkName: function chunkName() {
        return "providers/marketplace-named-queries";
      }
    }).then(function (module) {
      return module["default"]({
        nwApiSdk: nwApiSdk,
        appConfig: appConfig,
        serverRequest: serverRequest
      });
    });
  }), _defineProperty(_ref, WORDPRESS, function () {
    return _universalImport3({
      id: "./providers/wordpress",
      load: function load() {
        return Promise.all([import(
        /* webpackChunkName: 'providers/wordpress' */
        './providers/wordpress')]).then(function (proms) {
          return proms[0];
        });
      },
      path: function path() {
        return _path3.join(__dirname, './providers/wordpress');
      },
      resolve: function resolve() {
        return require.resolveWeak('./providers/wordpress');
      },
      chunkName: function chunkName() {
        return "providers/wordpress";
      }
    }).then(function (module) {
      return module["default"]({
        nwApiSdk: nwApiSdk,
        appConfig: appConfig,
        schema: schema,
        serverRequest: serverRequest
      });
    });
  }), _defineProperty(_ref, WORDPRESS_SEARCH, function () {
    return _universalImport4({
      id: "./providers/wordpress-search",
      load: function load() {
        return Promise.all([import(
        /* webpackChunkName: 'providers/wordpress-search' */
        './providers/wordpress-search')]).then(function (proms) {
          return proms[0];
        });
      },
      path: function path() {
        return _path4.join(__dirname, './providers/wordpress-search');
      },
      resolve: function resolve() {
        return require.resolveWeak('./providers/wordpress-search');
      },
      chunkName: function chunkName() {
        return "providers/wordpress-search";
      }
    }).then(function (module) {
      return module["default"]({
        nwApiSdk: nwApiSdk,
        appConfig: appConfig,
        serverRequest: serverRequest
      });
    });
  }), _defineProperty(_ref, WORDPRESS_TABLES, function () {
    return _universalImport5({
      id: "./providers/wordpress-tables",
      load: function load() {
        return Promise.all([import(
        /* webpackChunkName: 'providers/wordpress-tables' */
        './providers/wordpress-tables')]).then(function (proms) {
          return proms[0];
        });
      },
      path: function path() {
        return _path5.join(__dirname, './providers/wordpress-tables');
      },
      resolve: function resolve() {
        return require.resolveWeak('./providers/wordpress-tables');
      },
      chunkName: function chunkName() {
        return "providers/wordpress-tables";
      }
    }).then(function (module) {
      return module["default"]({
        nwApiSdk: nwApiSdk,
        appConfig: appConfig,
        schema: schema,
        serverRequest: serverRequest
      });
    });
  }), _ref;
}